<template>
  <div v-if="transaction">
    <user-details :data-user="transaction.source_user" title="Sender Details" hide-actions />
    <user-details
      :data-user="transaction.destination_user"
      title="Recipient Details"
      hide-actions
    />

    <merge-details :dataTransaction="transaction" class="mt-5" />
    <blockchain-transaction :transaction="transaction" />
    <!-- <cashout-documents :cashout.sync="transaction" class="mt-3" /> -->
  </div>
</template>
<script>
import UserDetails from "@/app/users/detail";
import MergeDetails from "./details";
import BlockchainTransaction from "../transfers/blockchaintransactions.vue";

export default {
  components: {
    UserDetails,
    MergeDetails,
    BlockchainTransaction,
  },
  props: {
    id: { required: true },
  },
  data: () => ({
    transaction: undefined,
  }),

  created() {
    this.$http
      .get(`api/v1/transactions/merges/${this.id}`)
      // eslint-disable-next-line arrow-parens
      .then((data) => {
        this.transaction = data;
      })
      .catch(() => window.Notify.warning("Something went wrong while fetching cashin details"));
  },
};
</script>
